/**
 * @generated SignedSource<<66c0337102742f669f55aa43ad75e553>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FilterMeetingOwnership = "ALL_MEETINGS" | "CUSTOM" | "ORGANIZED_BY_ME";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type aiPageSaveSettingsMutation$variables = {
  alwaysEmailWhenAttendee: boolean;
  autoRecordEnabled: boolean;
  autoRecordOwnership: FilterMeetingOwnership;
  autoShareSendTo: UserMeetingRecapSendTo;
  notAcceptedTermsOfService: boolean;
};
export type aiPageSaveSettingsMutation$data = {
  readonly acceptTermsOfService?: {
    readonly user: {
      readonly id: string;
    };
  } | null;
  readonly updateUserAutoRecordSettings: {
    readonly settings: {
      readonly enabled: boolean;
      readonly id: string;
      readonly meetingOwnershipFilter: FilterMeetingOwnership;
    } | null;
  } | null;
  readonly updateUserMeetingRecapAutoShareSettings: {
    readonly settings: {
      readonly alwaysEmailWhenAttendee: boolean;
      readonly id: string;
      readonly sendTo: UserMeetingRecapSendTo;
    } | null;
  } | null;
};
export type aiPageSaveSettingsMutation = {
  response: aiPageSaveSettingsMutation$data;
  variables: aiPageSaveSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "alwaysEmailWhenAttendee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoRecordEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoRecordOwnership"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autoShareSendTo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notAcceptedTermsOfService"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "autoRecordEnabled"
      },
      {
        "kind": "Variable",
        "name": "meetingOwnershipFilter",
        "variableName": "autoRecordOwnership"
      }
    ],
    "concreteType": "UpdateUserAutoRecordSettings",
    "kind": "LinkedField",
    "name": "updateUserAutoRecordSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserAutoRecordSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingOwnershipFilter",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "alwaysEmailWhenAttendee",
        "variableName": "alwaysEmailWhenAttendee"
      },
      {
        "kind": "Variable",
        "name": "sendTo",
        "variableName": "autoShareSendTo"
      }
    ],
    "concreteType": "UpdateUserMeetingRecapAutoShareSettings",
    "kind": "LinkedField",
    "name": "updateUserMeetingRecapAutoShareSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserMeetingRecapAutoShareSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alwaysEmailWhenAttendee",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "condition": "notAcceptedTermsOfService",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "input",
            "value": {}
          }
        ],
        "concreteType": "AcceptTermsOfServiceMutationPayload",
        "kind": "LinkedField",
        "name": "acceptTermsOfService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "acceptTermsOfService(input:{})"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiPageSaveSettingsMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiPageSaveSettingsMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "2d1d6b2f137d0a645778bc2c17a864e6",
    "id": null,
    "metadata": {},
    "name": "aiPageSaveSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation aiPageSaveSettingsMutation(\n  $autoRecordOwnership: FilterMeetingOwnership!\n  $autoRecordEnabled: Boolean!\n  $autoShareSendTo: UserMeetingRecapSendTo!\n  $alwaysEmailWhenAttendee: Boolean!\n  $notAcceptedTermsOfService: Boolean!\n) {\n  updateUserAutoRecordSettings(meetingOwnershipFilter: $autoRecordOwnership, enabled: $autoRecordEnabled) {\n    settings {\n      id\n      enabled\n      meetingOwnershipFilter\n    }\n  }\n  updateUserMeetingRecapAutoShareSettings(sendTo: $autoShareSendTo, alwaysEmailWhenAttendee: $alwaysEmailWhenAttendee) {\n    settings {\n      id\n      sendTo\n      alwaysEmailWhenAttendee\n    }\n  }\n  acceptTermsOfService(input: {}) @skip(if: $notAcceptedTermsOfService) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae828cb5973fc79c534adac1858fa7c5";

export default node;
